export const referenceDates = [
  { value: 'purchase', label: 'Fecha de compra' },
  { value: 'shipment', label: 'Fecha de envío' },
  { value: 'delivery', label: 'Fecha de entrega (cuando esté disponible)' },
]
